// extracted by mini-css-extract-plugin
export var attachment = "_j0-a";
export var emailContainer = "_j0-4";
export var emailContentPaddedContainer = "_j0-b";
export var emailHeader = "_j0-6";
export var emailIframe = "_j0-3";
export var emailInfoIcon = "_j0-9";
export var emailShortenedSummary = "_j0-e";
export var infoDropdown = "_j0-0";
export var infoRowBoundedContent = "_j0-d";
export var internal = "_j0-5";
export var merchant = "_j0-8";
export var messageInputContainer = "_j0-h";
export var normal = "_j0-7";
export var replyCard = "_j0-f";
export var subtleButton = "_j0-1";
export var subtleButtonIconContainer = "_j0-2";
export var toggleViewRepliesButton = "_j0-c";
export var wrappingText = "_j0-g";